import { render } from "./TeamContainer.vue?vue&type=template&id=44ea48ea&scoped=true"
import script from "./TeamContainer.vue?vue&type=script&lang=js"
export * from "./TeamContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-44ea48ea"

export default script